export default __webpack_public_path__ + "static/media/phone-2-black.63116937.png";